import {Skeleton} from '@mantine/core';
import {forwardRef} from 'react';
import {MdArrowForward, MdArrowForwardIos} from 'react-icons/md';
import type {z} from 'zod';
import type {EngineerCompanySchema} from '../../../../core/entities/company/schema';
import {CommonLink} from '../../../../shared/components/CommonLink';
import {CompanyCard} from '../Container/Presenter/CompanyCard';
import {COMPANY_LIST_LIMIT} from './constants';

type Props = {
  componentID: string;
  isLoading: boolean;
  companies: z.infer<typeof EngineerCompanySchema>[];
};

export const EngineerCompaniesFramePresentation = forwardRef<
  HTMLDivElement,
  Props
>(({componentID, isLoading, companies}, ref) => {
  return (
    <div
      id={componentID}
      ref={ref}
      className="w-full odd:bg-white py-16 pl-16 pc:pl-0"
    >
      <div className="mx-auto pc:w-[1200px] pc:h-[328px]">
        {companies.length > 0 && (
          <>
            <CommonLink
              href={'/company/industry/engineer'}
              className="flex hover:opacity-70"
            >
              <h2 className="font-bold text-black text-xl">エンジニア</h2>
              <span className="p-4">
                <MdArrowForwardIos size={20} />
              </span>
            </CommonLink>

            <div className="flex py-8 mb-8 gap-16 pc:gap-24 overflow-x-scroll">
              {companies.map((company) => (
                <CompanyCard
                  key={`engineer-card-${company.id}`}
                  company={company}
                  width={300}
                  bgColorStyle={'bg-white pc:bg-transparent'}
                />
              ))}
              {isLoading &&
                Array.from({length: 5}).map((_, index) => (
                  // biome-ignore lint/suspicious/noArrayIndexKey: order won't change
                  <div key={index}>
                    <Skeleton height={250} width={300} />
                  </div>
                ))}

              {companies.length >= COMPANY_LIST_LIMIT && (
                <CommonLink
                  href={'/company/industry/engineer'}
                  className="shadow-card bg-white p-16 rounded-16 hover:opacity-70 m-4 flex items-center"
                >
                  <div className="flex justify-center py-16">
                    <MdArrowForward size={40} />
                  </div>
                  <div>
                    <div className="text-md text-black text-center w-[200px]">
                      もっと見る
                    </div>
                  </div>
                </CommonLink>
              )}
            </div>
          </>
        )}
      </div>
    </div>
  );
});
